import type { TranslationKey, TranslationPluralKey } from './shared/types';

export function translationKey(key: string): TranslationKey {
	return key as unknown as TranslationKey;
}

export function translationPluralKey(key: string): TranslationPluralKey {
	return key as unknown as TranslationPluralKey;
}
